<script lang="ts" setup>
import { AppCard } from '@/core/components/';
import { computed, ref } from 'vue';
import EmailForm from './EmailForm.vue';
import ResetPasswordForm from './ResetPasswordForm.vue';
import VerifyForm from './VerifyForm.vue';
import { useAuthStore } from '@/modules/auth/store/auth';

withDefaults(
  defineProps<{
    nextPage?: string;
  }>(),
  {
    nextPage: '',
  }
);

const { user } = useAuthStore();

const formType = ref<'email' | 'otp' | 'password'>('email');

const username = ref();
const token = ref();

const cardTitle = computed((): string => {
  const titles = {
    email: 'Forgot your password',
    otp: 'Verify your email',
    password: 'New Password',
  };

  return titles[formType.value];
});

const parsedSubtitle = computed((): string => {
  const subtitles = {
    email: "Enter your email and we'll send you a password reset link",
    otp: `Enter the code sent to <br/> <b class="user-name">${username.value}</b>`,
    password: `Enter your password to log in <br/> <b class="user-name">${username.value}</b>`,
  };

  return subtitles[formType.value];
});
</script>

<template>
  <AppCard max-width="500" :title="cardTitle" trim-title>
    <div class="text-center pb-6" v-html="parsedSubtitle"></div>
    <EmailForm
      v-if="formType === 'email'"
      :username="user?.email"
      data-testid="email-form"
      class="forgot-password-form__email"
      @next="
        formType = 'otp';
        username = $event;
      "
    />

    <VerifyForm
      v-if="formType === 'otp'"
      :username="username"
      data-testid="verify-form"
      class="forgot-password-form__verify"
      @next="
        formType = 'password';
        token = $event;
      "
    />

    <ResetPasswordForm
      v-if="formType === 'password'"
      data-testid="reset-password-form"
      class="forgot-password-form__reset-password"
      :username="username"
      :token="token"
      :next-page="nextPage"
    />
  </AppCard>
</template>

<style lang="scss" scoped>
.v-card {
  margin-top: 132px;
}
.user-name {
  font-weight: 900;
}
</style>
